/**
 * Конфигурация атрибуции для дашбордов.
 */
import TypeIcon from '../../../shared/common/components/reports/params/attribution/icons/TypeIcon';
import FirstRegIcon from '../../../shared/common/components/reports/params/attribution/icons/FirstRegIcon';
import LastRegIcon from '../../../shared/common/components/reports/params/attribution/icons/LastRegIcon';

export const attrItems = [
  {
    id: 'type_applications',
    name: 'Тип регистрации:',
    selectValues: [
      { name: 'Нулевые заказы GC', id: '2', icon: null },
      { name: 'Прямая продажа', id: '4', icon: null },
      { name: 'Регистрации GC', id: '0', icon: null },
      { name: 'SCAN', id: '1', icon: null },
      { name: 'По умолчанию', id: 'blocks', icon: null },
    ],
    description: `Выбор типа регистрации по которым нужно создать отчёт:
                    <br><br>
                    Типы регистраци:
                    <br><br>
                    - SCAN - Это данные собираемые скриптом SCAN с форм;<br>
                    - Прямая продажа - эта регистрация создаётся автоматически в SCANе при создании платного заказа. Название регистрации будет являться название платного предложения;<br>
                    - Нулевые заказы GC - Заказы в GetCourse со стоимостью 0 руб.;<br>
                    - Регистрации GC -  Первая регистрация (попадания в базу) в GetCourse;<br>
                    <br><br>
                    <a href="https://doc.scananalytics.ru/otchety/tip-registracii/" rel="noopener noreferrer" target="_blank">Подробнее</a>.
                    `,
    icon: <TypeIcon />,
  },
  {
    id: 'attribution',
    name: 'Атрибуция:',
    selectValues: [
      { name: 'Первая регистрация', id: '1', icon: <FirstRegIcon /> },
      { name: 'Последняя регистрация', id: '2', icon: <LastRegIcon /> },
      { name: 'По умолчанию', id: 'blocks', icon: null },
    ],
    description: `Сервис SCAN позволяет определить к какой регистрации пользователя привязывать заказ. В сервисе 2 типа атрибуции:
                    <br><br>
                    - Первая регистрация <br>
                    - Последняя регистрация <br>
                    <br><br>
                    <a href="https://doc.scananalytics.ru/otchety/atribuciya/" rel="noopener noreferrer" target="_blank">Подробнее</a>.
                    `,
    icon: null,
  },
];
